// Data
import languageInformation from 'data/languageInformation'

// Constants
import { LANGUAGES, THEMES } from 'constants/options'
import { DEFAULT_DIRECTION, DEFAULT_LANGUAGE, DEFAULT_THEME, STORAGE_PREFIX, STORAGE_VERSION, REQUIRED_STORAGE_FIELDS } from 'constants/settings'

// Helper: System > Get direction
function getDirection (language) {
	if (!LANGUAGES.includes(language)) return DEFAULT_DIRECTION
	return languageInformation[language].direction || DEFAULT_DIRECTION
}

// Helper: System > Get language
function getLanguage () {
	let language = handleStorage('get', 'language')
	if (!LANGUAGES.includes(language)) {
		language = DEFAULT_LANGUAGE
		// TODO: Enable default language based on preference (by uncommenting lines below)
		// const browserPreference = window.navigator.userLanguage || window.navigator.language
		// if (!!browserPreference) language = browserPreference.split('-')[0]
		handleStorage('set', 'language', language)
	}
	return language
}

// Helper: System > Get theme
function getTheme () {
	let theme
	if (!!localStorage) theme = handleStorage('get', 'theme')
	if (!THEMES.includes(theme)) {
		theme = DEFAULT_THEME
		const otherTheme = THEMES.find(option => option !== DEFAULT_THEME)
		const isOtherThemePreferred = window.matchMedia(`(prefers-color-scheme: ${otherTheme})`).matches
		theme = isOtherThemePreferred ? otherTheme : DEFAULT_THEME
	}
	return theme
}

// Helper: System > Handle storage
function handleStorage (action, key, value) {
	const storageKey = `${STORAGE_PREFIX}V${STORAGE_VERSION}-${key}`
	switch (action) {
		case 'clear':
			localStorage.clear()
			break
		case 'get':
			return localStorage.getItem(storageKey)
		case 'set':
			localStorage.setItem(storageKey, value)
			break
		case 'remove':
			localStorage.removeItem(storageKey)
			break
		default:
			break
	}
}

// Helper: System > Handle session storage
function handleSystemStorage (action, key, value) {
	switch (action) {
		case 'clear':
			sessionStorage.clear()
			break
		case 'get':
			return sessionStorage.getItem(key)
		case 'set':
			sessionStorage.setItem(key, value)
			break
		case 'remove':
			sessionStorage.removeItem(key)
			break
		default:
			break
	}
}

// Helper: System > Remove non-required data from storage
function removeNonRequiredDataFromStorage ({ willKeepToken = false } = {}) {
	// Creates fields list
	const fields = [...REQUIRED_STORAGE_FIELDS]
	if (willKeepToken) fields.push('token')
	// Collects fields' data
	const requiredData = {}
	fields.forEach(field => requiredData[field] = handleStorage('get', field))
	// Clears storage
	handleStorage('clear')
	// Sets required fields' data back
	Object
		.keys(requiredData)
		.forEach(field => handleStorage('set', field, requiredData[field]))
}

// Export
export {
	getDirection,
	getLanguage,
	getTheme,
	handleStorage,
	handleSystemStorage,
	removeNonRequiredDataFromStorage
}
